<template>
    <div class="container">
        <div class="form-inline">
            <label for="search-box" class="sr-only">Search</label>
            <input id="search-box" class="form-control col-10" type="text" v-model="search" aria-label="Search"/>
            <input
                type="button"
                class="form-control btn btn-light col-2"
                @click="searchRequest"
                value="Search"
                :aria-disabled="!search.trim()"
                :class="{ 'disabled': !search.trim() }"
                @keydown.enter.prevent="!search.trim() ? $event.preventDefault() : searchRequest()"
            />
        </div>
        <table class="table">
            <thead>
            <tr>
                <th>Title</th>
                <th>Summary</th>
                <th>Category</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="error">
                <td colspan="4">{{ error }}</td>
            </tr>
            <tr v-for="row in shlData">
                <td>{{ row.title }}</td>
                <td v-html="row.snippet || row.summary"></td>
                <td>--</td>
                <td><a class="btn btn-light" :href="'/searchable-health-library/' + row.contentMeta.id">View</a></td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "SBSearchableHealthLibrary",
    data() {
        return {
            search: '',
            shlData: [],
            error: '',
        }
    },
    methods: {
        searchRequest() {
            if (this.search.trim()) {
                this.error = ''
                this.$http.post('/api/search-shl', {
                    search: this.search.trim()
                }).then(response => {
                    this.shlData = response.body
                    if (!this.shlData.length)
                        this.error = 'Your search did not find any matches. Please change your keywords and try again'
                })
            } else {
                this.error = 'You\'re trying to send empty message'
            }
        },
    },
}
</script>

<style scoped>

</style>
